/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF
import React from 'react'

// Make sure to use React style attributes
// fill-opacity -> fillOpacity
// stroke-width -> strokeWidth
// floodOpacity -> floodOpacity
// color-interpolation-filters -> colorInterpolationFilters
// remove stroke="[color]" and fill="[color]" on icons you want to be controlled by external styling
// adding in strok="none" and fill="none" may be necessary for certain icons
// when in doubt - remove all stroke="[color]" and add fill="none" to all paths
const LogoSVG = () => (
	<svg
		width="140"
		height="47"
		viewBox="0 0 140 47"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter="url(#filter0_d)">
			<path
				d="M68.0943 39H66.4343V32.9C66.4343 32.54 66.4143 32.2333 66.3743 31.98C66.3476 31.7267 66.281 31.46 66.1743 31.18C66.081 30.8867 65.9143 30.6667 65.6743 30.52C65.4343 30.3733 65.1343 30.3 64.7743 30.3C64.0276 30.3 63.1743 30.7533 62.2143 31.66C62.241 31.9267 62.2543 32.16 62.2543 32.36V39H60.5943V32.9C60.5943 32.5267 60.581 32.2133 60.5543 31.96C60.5276 31.7067 60.461 31.44 60.3543 31.16C60.2476 30.88 60.0743 30.6667 59.8343 30.52C59.6076 30.3733 59.3076 30.3 58.9343 30.3C58.2276 30.3 57.3876 30.74 56.4143 31.62V39H54.7543V31.78C54.7543 30.7 54.541 29.8133 54.1143 29.12L55.9343 28.92C56.121 29.3733 56.2476 29.8333 56.3143 30.3C57.3276 29.3133 58.2943 28.82 59.2143 28.82C60.5076 28.82 61.421 29.3733 61.9543 30.48C63.061 29.3733 64.0943 28.82 65.0543 28.82C66.1076 28.82 66.8743 29.14 67.3543 29.78C67.8476 30.4067 68.0943 31.2667 68.0943 32.36V39ZM81.3563 37.54L81.6963 38.58C81.603 38.62 81.4497 38.6867 81.2363 38.78C81.0363 38.86 80.8697 38.9267 80.7363 38.98C80.6163 39.02 80.463 39.06 80.2763 39.1C80.0897 39.1533 79.923 39.18 79.7763 39.18C79.3897 39.18 79.0697 39.0533 78.8163 38.8C78.5763 38.5467 78.423 38.22 78.3563 37.82C77.463 38.7533 76.463 39.22 75.3563 39.22C74.5563 39.22 73.8963 38.9867 73.3763 38.52C72.8697 38.04 72.6163 37.4 72.6163 36.6C72.6163 34.3467 74.5163 33.2067 78.3163 33.18V32.12C78.3163 30.7867 77.763 30.12 76.6563 30.12C76.1363 30.12 75.6097 30.2267 75.0763 30.44C74.543 30.6533 74.1163 30.94 73.7963 31.3L72.9763 30.12C74.0563 29.2533 75.3297 28.82 76.7963 28.82C77.8363 28.82 78.623 29.1067 79.1563 29.68C79.703 30.24 79.9763 31.0467 79.9763 32.1V37.06C79.9763 37.3267 80.003 37.52 80.0563 37.64C80.123 37.76 80.243 37.82 80.4163 37.82C80.5763 37.82 80.8897 37.7267 81.3563 37.54ZM78.3163 35.12V34.48C77.823 34.48 77.3963 34.5 77.0363 34.54C76.6897 34.5667 76.2763 34.64 75.7963 34.76C75.3297 34.88 74.963 35.0933 74.6963 35.4C74.443 35.6933 74.3163 36.0733 74.3163 36.54C74.3163 36.9667 74.4563 37.2867 74.7363 37.5C75.0297 37.7133 75.4163 37.82 75.8963 37.82C76.5763 37.82 77.1497 37.5467 77.6163 37C78.083 36.44 78.3163 35.8133 78.3163 35.12ZM92.8991 39H91.2591V32.9C91.2591 32.5933 91.2525 32.34 91.2391 32.14C91.2258 31.94 91.1858 31.7133 91.1191 31.46C91.0658 31.2067 90.9791 31.0067 90.8591 30.86C90.7525 30.7 90.5858 30.5667 90.3591 30.46C90.1458 30.3533 89.8858 30.3 89.5791 30.3C88.6991 30.3 87.7925 30.74 86.8591 31.62V39H85.2191V31.96C85.2191 30.68 84.9991 29.74 84.5591 29.14L86.3791 28.9C86.5791 29.4067 86.7058 29.88 86.7591 30.32C87.7591 29.32 88.7925 28.82 89.8591 28.82C90.9125 28.82 91.6791 29.14 92.1591 29.78C92.6525 30.4067 92.8991 31.2667 92.8991 32.36V39ZM106.177 37.54L106.517 38.58C106.423 38.62 106.27 38.6867 106.057 38.78C105.857 38.86 105.69 38.9267 105.557 38.98C105.437 39.02 105.283 39.06 105.097 39.1C104.91 39.1533 104.743 39.18 104.597 39.18C104.21 39.18 103.89 39.0533 103.637 38.8C103.397 38.5467 103.243 38.22 103.177 37.82C102.283 38.7533 101.283 39.22 100.177 39.22C99.3766 39.22 98.7166 38.9867 98.1966 38.52C97.69 38.04 97.4366 37.4 97.4366 36.6C97.4366 34.3467 99.3366 33.2067 103.137 33.18V32.12C103.137 30.7867 102.583 30.12 101.477 30.12C100.957 30.12 100.43 30.2267 99.8966 30.44C99.3633 30.6533 98.9366 30.94 98.6166 31.3L97.7966 30.12C98.8766 29.2533 100.15 28.82 101.617 28.82C102.657 28.82 103.443 29.1067 103.977 29.68C104.523 30.24 104.797 31.0467 104.797 32.1V37.06C104.797 37.3267 104.823 37.52 104.877 37.64C104.943 37.76 105.063 37.82 105.237 37.82C105.397 37.82 105.71 37.7267 106.177 37.54ZM103.137 35.12V34.48C102.643 34.48 102.217 34.5 101.857 34.54C101.51 34.5667 101.097 34.64 100.617 34.76C100.15 34.88 99.7833 35.0933 99.5166 35.4C99.2633 35.6933 99.1366 36.0733 99.1366 36.54C99.1366 36.9667 99.2766 37.2867 99.5566 37.5C99.85 37.7133 100.237 37.82 100.717 37.82C101.397 37.82 101.97 37.5467 102.437 37C102.903 36.44 103.137 35.8133 103.137 35.12ZM117.859 30.24H115.719C116.159 30.8133 116.379 31.4867 116.379 32.26C116.379 33.22 116.033 34.04 115.339 34.72C114.646 35.3867 113.819 35.72 112.859 35.72C112.766 35.72 112.633 35.7067 112.459 35.68C112.299 35.6533 112.179 35.64 112.099 35.64C111.913 35.64 111.733 35.7733 111.559 36.04C111.386 36.2933 111.299 36.5267 111.299 36.74C111.299 36.9667 111.366 37.14 111.499 37.26C111.646 37.38 111.786 37.4467 111.919 37.46C112.066 37.4733 112.266 37.48 112.519 37.48C112.733 37.48 113.059 37.4733 113.499 37.46C113.939 37.4333 114.259 37.42 114.459 37.42C116.539 37.42 117.579 38.12 117.579 39.52C117.579 40.8933 117.073 41.9133 116.059 42.58C115.059 43.26 113.853 43.6 112.439 43.6C111.533 43.6 110.706 43.3933 109.959 42.98C109.226 42.5667 108.859 41.9333 108.859 41.08C108.859 40.2133 109.373 39.4267 110.399 38.72C109.786 38.4133 109.479 37.9267 109.479 37.26C109.479 37.22 109.559 37.08 109.719 36.84C110.266 36.0933 110.646 35.52 110.859 35.12C110.379 34.8 109.999 34.3867 109.719 33.88C109.453 33.3733 109.319 32.84 109.319 32.28C109.319 31.32 109.666 30.5067 110.359 29.84C111.053 29.16 111.879 28.82 112.839 28.82C113.093 28.82 113.459 28.8667 113.939 28.96C114.433 29.0533 114.799 29.1 115.039 29.1C115.706 29.1 116.766 29 118.219 28.8L117.859 30.24ZM112.839 34.52C113.333 34.52 113.753 34.3067 114.099 33.88C114.459 33.44 114.639 32.9067 114.639 32.28C114.639 31.6533 114.459 31.12 114.099 30.68C113.753 30.24 113.339 30.02 112.859 30.02C112.366 30.02 111.939 30.24 111.579 30.68C111.233 31.1067 111.059 31.6333 111.059 32.26C111.059 32.8867 111.233 33.42 111.579 33.86C111.939 34.3 112.359 34.52 112.839 34.52ZM111.599 39.06C111.319 39.26 111.079 39.5133 110.879 39.82C110.679 40.14 110.579 40.4467 110.579 40.74C110.579 41.1933 110.813 41.5533 111.279 41.82C111.746 42.1 112.233 42.24 112.739 42.24C113.593 42.24 114.353 42.0667 115.019 41.72C115.699 41.3733 116.039 40.8333 116.039 40.1C116.039 39.86 115.979 39.66 115.859 39.5C115.739 39.34 115.566 39.2267 115.339 39.16C115.113 39.0933 114.899 39.0467 114.699 39.02C114.513 39.0067 114.279 39 113.999 39C113.199 39 112.399 39.02 111.599 39.06ZM128.11 36.94L128.85 38.14C127.93 38.8867 126.81 39.26 125.49 39.26C124.05 39.26 122.917 38.78 122.09 37.82C121.277 36.8467 120.87 35.62 120.87 34.14C120.87 33.2333 121.017 32.3867 121.31 31.6C121.617 30.8133 122.104 30.1533 122.77 29.62C123.45 29.0867 124.257 28.82 125.19 28.82C126.35 28.82 127.284 29.1667 127.99 29.86C128.697 30.54 129.05 31.4533 129.05 32.6C129.05 33.4533 128.71 33.88 128.03 33.88H122.63V34.08C122.63 35.04 122.884 35.9133 123.39 36.7C123.91 37.4733 124.624 37.86 125.53 37.86C125.97 37.86 126.43 37.78 126.91 37.62C127.39 37.4467 127.79 37.22 128.11 36.94ZM122.75 32.64H126.93C127.077 32.64 127.17 32.6133 127.21 32.56C127.25 32.4933 127.27 32.38 127.27 32.22C127.27 31.62 127.097 31.1133 126.75 30.7C126.404 30.2867 125.937 30.08 125.35 30.08C124.71 30.08 124.144 30.34 123.65 30.86C123.17 31.38 122.87 31.9733 122.75 32.64ZM135.153 39H133.493V31.8C133.493 30.6267 133.28 29.7267 132.853 29.1L134.653 28.88C134.893 29.4667 135.046 30.0867 135.113 30.74C135.473 30.18 135.946 29.7333 136.533 29.4C137.12 29.0533 137.733 28.88 138.373 28.88L137.973 30.64C136.893 30.64 135.953 31.2267 135.153 32.4V39Z"
				fill="#A1B4CF"
			/>
		</g>
		<g filter="url(#filter1_d)">
			<path
				d="M54.2817 18.42L54.9817 17.2C55.7551 17.7333 56.4617 18 57.1017 18C57.6484 18 58.1217 17.8933 58.5217 17.68C58.9217 17.4667 59.1217 17.1067 59.1217 16.6C59.1217 16.2 58.9617 15.8533 58.6417 15.56C58.3217 15.2533 57.9284 14.9933 57.4617 14.78C57.0084 14.5667 56.5551 14.3467 56.1017 14.12C55.6484 13.88 55.2617 13.56 54.9417 13.16C54.6217 12.76 54.4617 12.28 54.4617 11.72C54.4617 10.7867 54.8017 10.0733 55.4817 9.58C56.1617 9.07333 56.9884 8.82 57.9617 8.82C58.9751 8.82 59.8617 9.05333 60.6217 9.52L60.0417 10.8C59.4151 10.32 58.7817 10.08 58.1417 10.08C57.6217 10.08 57.1617 10.1867 56.7617 10.4C56.3617 10.6133 56.1617 10.96 56.1617 11.44C56.1617 11.84 56.3217 12.1933 56.6417 12.5C56.9617 12.7933 57.3484 13.0467 57.8017 13.26C58.2684 13.46 58.7284 13.68 59.1817 13.92C59.6484 14.1467 60.0417 14.4667 60.3617 14.88C60.6817 15.2933 60.8417 15.7867 60.8417 16.36C60.8417 17.3467 60.5017 18.08 59.8217 18.56C59.1551 19.0267 58.3017 19.26 57.2617 19.26C56.3684 19.26 55.3751 18.98 54.2817 18.42ZM67.3955 23.32H65.4755V11.96C65.4755 10.7333 65.2688 9.79333 64.8555 9.14L66.6155 8.92C66.8021 9.33333 66.9288 9.78667 66.9955 10.28C67.7555 9.32 68.7288 8.84 69.9155 8.84C71.2355 8.84 72.2555 9.35333 72.9755 10.38C73.6955 11.4067 74.0555 12.6067 74.0555 13.98C74.0555 15.4467 73.6688 16.6933 72.8955 17.72C72.1221 18.7467 71.0221 19.26 69.5955 19.26C68.5688 19.26 67.7421 18.9667 67.1155 18.38V22.14L67.3955 23.32ZM67.1155 11.62V14.98C67.1155 15.8333 67.3155 16.5333 67.7155 17.08C68.1155 17.6267 68.7288 17.9 69.5555 17.9C70.0621 17.9 70.4955 17.7867 70.8555 17.56C71.2288 17.3333 71.5155 17.0333 71.7155 16.66C71.9155 16.2733 72.0621 15.8667 72.1555 15.44C72.2488 15.0133 72.2955 14.5667 72.2955 14.1C72.2955 13.06 72.0621 12.1667 71.5955 11.42C71.1288 10.6733 70.4021 10.3 69.4155 10.3C68.6288 10.3 67.8621 10.74 67.1155 11.62ZM86.5888 17.54L86.9288 18.58C86.8354 18.62 86.6821 18.6867 86.4688 18.78C86.2688 18.86 86.1021 18.9267 85.9688 18.98C85.8488 19.02 85.6954 19.06 85.5088 19.1C85.3221 19.1533 85.1554 19.18 85.0088 19.18C84.6221 19.18 84.3021 19.0533 84.0488 18.8C83.8088 18.5467 83.6554 18.22 83.5888 17.82C82.6954 18.7533 81.6954 19.22 80.5888 19.22C79.7888 19.22 79.1288 18.9867 78.6088 18.52C78.1021 18.04 77.8488 17.4 77.8488 16.6C77.8488 14.3467 79.7488 13.2067 83.5488 13.18V12.12C83.5488 10.7867 82.9954 10.12 81.8888 10.12C81.3688 10.12 80.8421 10.2267 80.3088 10.44C79.7754 10.6533 79.3488 10.94 79.0288 11.3L78.2088 10.12C79.2888 9.25333 80.5621 8.82 82.0288 8.82C83.0688 8.82 83.8554 9.10667 84.3888 9.68C84.9354 10.24 85.2088 11.0467 85.2088 12.1V17.06C85.2088 17.3267 85.2354 17.52 85.2888 17.64C85.3554 17.76 85.4754 17.82 85.6488 17.82C85.8088 17.82 86.1221 17.7267 86.5888 17.54ZM83.5488 15.12V14.48C83.0554 14.48 82.6288 14.5 82.2688 14.54C81.9221 14.5667 81.5088 14.64 81.0288 14.76C80.5621 14.88 80.1954 15.0933 79.9288 15.4C79.6754 15.6933 79.5488 16.0733 79.5488 16.54C79.5488 16.9667 79.6888 17.2867 79.9688 17.5C80.2621 17.7133 80.6488 17.82 81.1288 17.82C81.8088 17.82 82.3821 17.5467 82.8487 17C83.3154 16.44 83.5488 15.8133 83.5488 15.12ZM96.7516 17L97.5116 18.26C96.8849 18.6333 96.3449 18.8933 95.8916 19.04C95.4516 19.1867 94.8982 19.26 94.2316 19.26C92.8982 19.26 91.8116 18.7333 90.9716 17.68C90.1449 16.6133 89.7316 15.4 89.7316 14.04C89.7316 12.5333 90.1516 11.2867 90.9916 10.3C91.8449 9.31333 93.0116 8.82 94.4916 8.82C95.5182 8.82 96.4782 9.16 97.3716 9.84L96.4716 11C96.0849 10.6667 95.7316 10.44 95.4116 10.32C95.1049 10.1867 94.7116 10.12 94.2316 10.12C93.3649 10.12 92.6916 10.5133 92.2116 11.3C91.7449 12.0867 91.5116 12.94 91.5116 13.86C91.5116 14.4733 91.5982 15.0733 91.7716 15.66C91.9582 16.2333 92.2716 16.7467 92.7116 17.2C93.1649 17.6533 93.7049 17.88 94.3316 17.88C94.8116 17.88 95.2182 17.8133 95.5516 17.68C95.8849 17.5467 96.2849 17.32 96.7516 17ZM107.975 16.94L108.715 18.14C107.795 18.8867 106.675 19.26 105.355 19.26C103.915 19.26 102.782 18.78 101.955 17.82C101.142 16.8467 100.735 15.62 100.735 14.14C100.735 13.2333 100.882 12.3867 101.175 11.6C101.482 10.8133 101.969 10.1533 102.635 9.62C103.315 9.08667 104.122 8.82 105.055 8.82C106.215 8.82 107.149 9.16667 107.855 9.86C108.562 10.54 108.915 11.4533 108.915 12.6C108.915 13.4533 108.575 13.88 107.895 13.88H102.495V14.08C102.495 15.04 102.749 15.9133 103.255 16.7C103.775 17.4733 104.489 17.86 105.395 17.86C105.835 17.86 106.295 17.78 106.775 17.62C107.255 17.4467 107.655 17.22 107.975 16.94ZM102.615 12.64H106.795C106.942 12.64 107.035 12.6133 107.075 12.56C107.115 12.4933 107.135 12.38 107.135 12.22C107.135 11.62 106.962 11.1133 106.615 10.7C106.269 10.2867 105.802 10.08 105.215 10.08C104.575 10.08 104.009 10.34 103.515 10.86C103.035 11.38 102.735 11.9733 102.615 12.64Z"
				fill="#818B9D"
			/>
		</g>
		<rect
			y="0.98999"
			width="39.0862"
			height="39.0862"
			rx="5"
			fill="#86B3E7"
			fillOpacity="0.5"
		/>
		<g filter="url(#filter2_d)">
			<rect
				x="5.10822"
				y="5.51483"
				width="38.8918"
				height="38.8918"
				rx="5"
				fill="#BFC6DA"
			/>
		</g>
		<g filter="url(#filter3_d)">
			<path
				d="M8.14594 12.9237C8.14594 10.3336 10.2457 8.23386 12.8358 8.23386H39.1092C40.2137 8.23386 41.1092 9.12929 41.1092 10.2339V11.8617C41.1092 12.9663 40.2137 13.8617 39.1092 13.8617H9.08391C8.56588 13.8617 8.14594 13.4418 8.14594 12.9237V12.9237Z"
				fill="#E8E8E8"
			/>
			<path
				d="M12.8358 8.33386H39.1092C40.1585 8.33386 41.0092 9.18451 41.0092 10.2339V11.8617C41.0092 12.9111 40.1585 13.7617 39.1092 13.7617H9.08391C8.62111 13.7617 8.24594 13.3865 8.24594 12.9237C8.24594 10.3888 10.3009 8.33386 12.8358 8.33386Z"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<g filter="url(#filter4_d)">
			<path
				d="M8.14594 38.3732C8.14594 37.2687 9.04137 36.3732 10.1459 36.3732H40.1712C40.6892 36.3732 41.1092 36.7932 41.1092 37.3112V37.3112C41.1092 39.9014 39.0094 42.0011 36.4193 42.0011H10.1459C9.04136 42.0011 8.14594 41.1057 8.14594 40.0011V38.3732Z"
				fill="#E8E8E8"
			/>
			<path
				d="M10.1459 36.4732H40.1712C40.634 36.4732 41.0092 36.8484 41.0092 37.3112C41.0092 39.8461 38.9542 41.9011 36.4193 41.9011H10.1459C9.09659 41.9011 8.24594 41.0504 8.24594 40.0011V38.3732C8.24594 37.3239 9.09659 36.4732 10.1459 36.4732Z"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<g filter="url(#filter5_d)">
			<path
				d="M8.03979 17.2737C8.03979 16.7214 8.48751 16.2737 9.03979 16.2737H29.5513C30.1035 16.2737 30.5513 16.7214 30.5513 17.2737V24.1175C30.5513 24.6698 30.1035 25.1175 29.5513 25.1175H13.0398C10.2784 25.1175 8.03979 22.8789 8.03979 20.1175V17.2737Z"
				fill="#E8E8E8"
			/>
			<path
				d="M9.03979 16.3737H29.5513C30.0483 16.3737 30.4513 16.7766 30.4513 17.2737V24.1175C30.4513 24.6145 30.0483 25.0175 29.5513 25.0175H13.0398C10.3336 25.0175 8.13979 22.8237 8.13979 20.1175V17.2737C8.13979 16.7766 8.54274 16.3737 9.03979 16.3737Z"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<g filter="url(#filter6_d)">
			<path
				d="M24.1194 28.5294C24.1194 27.9771 24.5672 27.5294 25.1194 27.5294H36.003C38.7645 27.5294 41.003 29.768 41.003 32.5294V32.9613C41.003 33.5136 40.5553 33.9613 40.003 33.9613H25.1194C24.5672 33.9613 24.1194 33.5136 24.1194 32.9613V28.5294Z"
				fill="#E8E8E8"
			/>
			<path
				d="M25.1194 27.6294H36.003C38.7092 27.6294 40.903 29.8232 40.903 32.5294V32.9613C40.903 33.4583 40.5001 33.8613 40.003 33.8613H25.1194C24.6224 33.8613 24.2194 33.4583 24.2194 32.9613V28.5294C24.2194 28.0324 24.6224 27.6294 25.1194 27.6294Z"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<g filter="url(#filter7_d)">
			<rect
				x="32.2653"
				y="16.2737"
				width="8.84379"
				height="8.84379"
				rx="2"
				fill="#E2D8D8"
			/>
			<rect
				x="32.3653"
				y="16.3737"
				width="8.64379"
				height="8.64379"
				rx="1.9"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<g filter="url(#filter8_d)">
			<rect
				x="8.14594"
				y="27.5294"
				width="13.6677"
				height="6.43185"
				rx="2"
				fill="#E2D8D8"
			/>
			<rect
				x="8.24594"
				y="27.6294"
				width="13.4677"
				height="6.23185"
				rx="1.9"
				stroke="#A4A4A4"
				strokeWidth="0.2"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d"
				x="53.1143"
				y="28.8"
				width="86.2588"
				height="16.8"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_d"
				x="50.2817"
				y="5.82001"
				width="62.6338"
				height="22.5"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="2" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter2_d"
				x="3.10822"
				y="3.51483"
				width="42.8918"
				height="42.8918"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="1" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter3_d"
				x="7.14594"
				y="7.73386"
				width="34.9632"
				height="7.62787"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter4_d"
				x="7.14594"
				y="35.8732"
				width="34.9632"
				height="7.62787"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter5_d"
				x="7.03979"
				y="15.7737"
				width="24.5115"
				height="10.8438"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter6_d"
				x="23.1194"
				y="27.0294"
				width="18.8836"
				height="8.43185"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter7_d"
				x="31.2653"
				y="15.7737"
				width="10.8438"
				height="10.8438"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
			<filter
				id="filter8_d"
				x="7.14594"
				y="27.0294"
				width="15.6677"
				height="8.43185"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="0.5" />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
)

const InfoIcon = (props) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.625 3C6.86203 3 3 6.86203 3 11.625C3 16.388 6.86203 20.25 11.625 20.25C16.388 20.25 20.25 16.388 20.25 11.625C20.25 6.86203 16.388 3 11.625 3Z"
			strokeMiterlimit="10"
			fill="none"
		/>
		<path
			d="M10.3125 10.3125H11.8125V15.75"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
		<path
			d="M9.75 15.9375H13.875"
			strokeMiterlimit="10"
			strokeLinecap="round"
			fill="none"
		/>
		<path
			d="M11.625 6.09375C11.384 6.09375 11.1483 6.16523 10.9479 6.29915C10.7475 6.43307 10.5913 6.62341 10.499 6.84611C10.4068 7.06881 10.3826 7.31386 10.4297 7.55027C10.4767 7.78669 10.5928 8.00385 10.7632 8.17429C10.9337 8.34474 11.1508 8.46081 11.3872 8.50784C11.6237 8.55486 11.8687 8.53073 12.0914 8.43849C12.3141 8.34624 12.5044 8.19003 12.6384 7.98961C12.7723 7.78918 12.8438 7.55355 12.8438 7.3125C12.8438 6.98927 12.7154 6.67928 12.4868 6.45071C12.2582 6.22215 11.9482 6.09375 11.625 6.09375Z"
			stroke="none"
		/>
	</svg>
)

const CircledProfileIcon = (props) => (
	<svg
		{...props}
		width="35"
		height="35"
		viewBox="0 0 38 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			stroke="none"
			d="M19.2658 0.00176537C8.5806 -0.142555 -0.142555 8.5806 0.00176537 19.2658C0.144259 29.5134 8.48835 37.8575 18.736 38C29.423 38.1462 38.1443 29.423 37.9982 18.7378C37.8575 8.48835 29.5134 0.144259 19.2658 0.00176537ZM30.8132 29.8934C30.7768 29.9328 30.7322 29.9636 30.6826 29.9838C30.633 30.004 30.5795 30.013 30.526 30.0102C30.4724 30.0074 30.4202 29.9929 30.3729 29.9677C30.3256 29.9424 30.2845 29.9071 30.2524 29.8642C29.4354 28.7953 28.4348 27.8801 27.2975 27.1614C24.9719 25.6689 22.0252 24.8468 19.0009 24.8468C15.9766 24.8468 13.0299 25.6689 10.7043 27.1614C9.56698 27.8798 8.56644 28.7946 7.74939 29.8633C7.71729 29.9062 7.67614 29.9415 7.62887 29.9668C7.58159 29.992 7.52934 30.0065 7.47582 30.0093C7.4223 30.0121 7.36882 30.0031 7.31918 29.9829C7.26953 29.9627 7.22494 29.9319 7.18855 29.8925C4.50828 26.9991 2.99001 23.2184 2.92471 19.2749C2.77582 10.3864 10.0695 2.94663 18.9616 2.92471C27.8538 2.90279 35.0771 10.1234 35.0771 19.0009C35.0801 23.0395 33.5572 26.9301 30.8132 29.8934Z"
		/>
		<path
			stroke="none"
			d="M19.001 8.7706C17.1997 8.7706 15.5711 9.44562 14.4138 10.6723C13.2565 11.8991 12.6783 13.5953 12.8089 15.4157C13.0738 19.0009 15.8515 21.9238 19.001 21.9238C22.1505 21.9238 24.9227 19.0009 25.1931 15.4166C25.3283 13.6135 24.7546 11.9329 23.5781 10.6833C22.4163 9.45018 20.7904 8.7706 19.001 8.7706Z"
		/>
	</svg>
)

const CircledInfoIcon = (props) => (
	<svg
		{...props}
		width="35"
		height="35"
		viewBox="0 0 38 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19 2C15.6377 2 12.3509 2.99703 9.55531 4.86502C6.75968 6.733 4.58074 9.38804 3.29406 12.4944C2.00737 15.6007 1.67071 19.0189 2.32666 22.3165C2.98261 25.6142 4.6017 28.6433 6.97919 31.0208C9.35668 33.3983 12.3858 35.0174 15.6835 35.6733C18.9811 36.3293 22.3993 35.9926 25.5056 34.7059C28.612 33.4193 31.267 31.2403 33.135 28.4447C35.003 25.6491 36 22.3623 36 19C36 14.4913 34.2089 10.1673 31.0208 6.97918C27.8327 3.79107 23.5087 2 19 2Z"
			fill="none"
			strokeWidth="3"
			strokeMiterlimit="10"
		/>
		<path
			d="M13.5913 13.8121C13.5913 13.8121 13.6724 12.1217 15.4816 10.6661C16.5547 9.80162 17.8413 9.55144 19.0004 9.53406C20.0561 9.52054 20.9989 9.69536 21.563 9.96389C22.5289 10.4237 24.4095 11.5461 24.4095 13.9328C24.4095 16.4442 22.7674 17.5849 20.8965 18.8397C19.0255 20.0944 18.5174 21.4563 18.5174 22.8636"
			fill="none"
			strokeWidth="2"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
		<path
			d="M18.4208 29.8182C19.4877 29.8182 20.3526 28.9533 20.3526 27.8863C20.3526 26.8194 19.4877 25.9545 18.4208 25.9545C17.3539 25.9545 16.489 26.8194 16.489 27.8863C16.489 28.9533 17.3539 29.8182 18.4208 29.8182Z"
			stroke="none"
		/>
	</svg>
)

const TimerFieldIcon = (props) => (
	<svg
		{...props}
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="none"
			d="M8.5 1C4.35938 1 1 4.35938 1 8.5C1 12.6406 4.35938 16 8.5 16C12.6406 16 16 12.6406 16 8.5C16 4.35938 12.6406 1 8.5 1Z"
			strokeMiterlimit="10"
		/>
		<path
			fill="none"
			d="M8.5 3.50012V9.12512H12.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

const TextFieldIcon = (props) => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="none"
			d="M1.25 16.2305L5.9375 3.73047L10.625 16.2305"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fill="none"
			d="M8.98438 11.8555H2.89062"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fill="none"
			d="M12.7344 9.35547C13.2105 8.23477 14.3359 7.48047 15.625 7.48047C17.4219 7.48047 18.75 8.73047 18.75 10.6055V16.2305"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fill="none"
			d="M12.5 14.0039C12.5 15.4102 13.5492 16.2695 14.8438 16.2695C16.9531 16.2695 18.75 15.2148 18.75 12.1289V11.543C17.9688 11.543 16.4844 11.582 15.1562 11.7383C13.8762 11.8891 12.5 12.4805 12.5 14.0039Z"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

const SwitchIcon = (props) => (
	<svg
		{...props}
		width="20"
		height="11"
		viewBox="0 0 20 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ stroke: 'none' }}
	>
		<path
			d="M14.375 0H5.625C2.52344 0 0 2.46736 0 5.5C0 8.53264 2.52344 11 5.625 11H14.375C17.4766 11 20 8.53264 20 5.5C20 2.46736 17.4766 0 14.375 0ZM14.375 9.77778C13.5097 9.77778 12.6638 9.52689 11.9444 9.05684C11.2249 8.58679 10.6642 7.9187 10.333 7.13703C10.0019 6.35537 9.91525 5.49525 10.0841 4.66545C10.2529 3.83564 10.6696 3.07341 11.2814 2.47515C11.8933 1.8769 12.6728 1.46948 13.5215 1.30442C14.3701 1.13936 15.2498 1.22407 16.0492 1.54785C16.8487 1.87162 17.5319 2.41992 18.0127 3.12339C18.4934 3.82687 18.75 4.65394 18.75 5.5C18.7488 6.63416 18.2874 7.72153 17.4672 8.52351C16.647 9.32548 15.5349 9.77656 14.375 9.77778V9.77778Z"
			fill="currentColor"
		/>
	</svg>
)

const ScrollArrow = (props) => (
	<svg
		{...props}
		width="12"
		height="63"
		viewBox="0 0 12 63"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="none"
			d="M1.77 58L5.81706 62L9.77 58"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			stroke="none"
			d="M5.30005 42.5285V42.5285C5.5716 42.2414 6.0285 42.2414 6.30005 42.5285V42.5285V54.6829L5.80005 55L5.30005 54.6829V42.5285Z"
		/>
		<path
			stroke="none"
			d="M4.0425 4.712C3.37117 4.712 2.84233 4.4745 2.456 3.9995C2.076 3.53083 1.886 2.9545 1.886 2.2705C1.886 1.40283 2.06967 0.658666 2.437 0.0379996L3.4915 0.4845C3.02917 0.9785 2.798 1.53267 2.798 2.147C2.798 2.47 2.88667 2.7455 3.064 2.9735C3.24133 3.20783 3.48833 3.325 3.805 3.325C4.033 3.325 4.23567 3.249 4.413 3.097C4.59033 2.945 4.72967 2.755 4.831 2.527C4.93233 2.30533 5.0495 2.0615 5.1825 1.7955C5.32183 1.5295 5.46117 1.2825 5.6005 1.0545C5.73983 0.832833 5.93617 0.646 6.1895 0.494C6.44917 0.342 6.74683 0.266 7.0825 0.266C7.73483 0.266 8.22883 0.490833 8.5645 0.9405C8.90017 1.3965 9.068 2.00133 9.068 2.755C9.068 3.04 9.011 3.36933 8.897 3.743C8.783 4.11667 8.65 4.40167 8.498 4.598L7.681 3.9425C7.99767 3.58783 8.156 3.15083 8.156 2.6315C8.156 2.3655 8.08633 2.13433 7.947 1.938C7.80767 1.748 7.61133 1.653 7.358 1.653C7.13633 1.653 6.94 1.729 6.769 1.881C6.60433 2.033 6.47133 2.21983 6.37 2.4415C6.26867 2.6695 6.14833 2.9165 6.009 3.1825C5.86967 3.4485 5.72717 3.69233 5.5815 3.914C5.44217 4.142 5.2395 4.332 4.9735 4.484C4.7075 4.636 4.39717 4.712 4.0425 4.712ZM2.589 11.6624C2.342 11.2634 2.1615 10.8898 2.0475 10.5414C1.93983 10.1994 1.886 9.80677 1.886 9.36344C1.886 8.2931 2.22167 7.46977 2.893 6.89344C3.56433 6.32344 4.4415 6.03844 5.5245 6.03844C6.55683 6.03844 7.40867 6.33927 8.08 6.94094C8.75133 7.5426 9.087 8.35327 9.087 9.37294C9.087 9.7656 9.03 10.1773 8.916 10.6079C8.802 11.0386 8.63417 11.3774 8.4125 11.6244L7.5385 10.9404C7.7285 10.7694 7.8805 10.5414 7.9945 10.2564C8.1085 9.97144 8.1655 9.69277 8.1655 9.42044C8.1655 8.95177 8.0325 8.56227 7.7665 8.25194C7.5005 7.94794 7.18067 7.73894 6.807 7.62494C6.43333 7.51094 6.01533 7.45394 5.553 7.45394C5.249 7.45394 4.93867 7.49194 4.622 7.56794C4.31167 7.65027 4.014 7.76744 3.729 7.91944C3.45033 8.07144 3.22233 8.28044 3.045 8.54644C2.86767 8.81244 2.779 9.1101 2.779 9.43944C2.779 10.0284 3.0165 10.5699 3.4915 11.0639L2.589 11.6624ZM2 18.5882L2 17.1062L5.097 15.1777L5.097 14.6552L2 14.6552L2 13.3537L8.3745 13.3537C8.38717 13.3537 8.479 13.3315 8.65 13.2872C8.82733 13.2428 8.92867 13.2175 8.954 13.2112L8.954 15.5957C8.954 16.2987 8.80517 16.8655 8.5075 17.2962C8.20983 17.7268 7.72533 17.9422 7.054 17.9422C6.66133 17.9422 6.294 17.7933 5.952 17.4957C5.61 17.198 5.3915 16.8528 5.2965 16.4602L2 18.5882ZM7.0635 16.5647C7.36117 16.5647 7.59233 16.4602 7.757 16.2512C7.92167 16.0422 8.004 15.7825 8.004 15.4722L8.004 14.6552L6.028 14.6552L6.028 15.2632C6.028 16.1308 6.37317 16.5647 7.0635 16.5647ZM5.4675 26.1105C4.4225 26.1105 3.56433 25.8096 2.893 25.208C2.228 24.6063 1.8955 23.7893 1.8955 22.757C1.8955 21.7246 2.23117 20.9171 2.9025 20.3345C3.58017 19.7581 4.4415 19.47 5.4865 19.47C6.53783 19.47 7.396 19.7613 8.061 20.344C8.726 20.9266 9.0585 21.7341 9.0585 22.7665C9.0585 23.8241 8.726 24.6443 8.061 25.227C7.40233 25.816 6.53783 26.1105 5.4675 26.1105ZM5.4295 24.7045C5.76517 24.7045 6.08183 24.6728 6.3795 24.6095C6.6835 24.5461 6.97167 24.4448 7.244 24.3055C7.52267 24.1661 7.74433 23.9635 7.909 23.6975C8.07367 23.4378 8.156 23.1306 8.156 22.776C8.156 22.4276 8.07683 22.1236 7.9185 21.864C7.7665 21.6043 7.5575 21.4048 7.2915 21.2655C7.03183 21.1261 6.75317 21.0248 6.4555 20.9615C6.16417 20.8981 5.85383 20.8665 5.5245 20.8665C5.18883 20.8665 4.869 20.8981 4.565 20.9615C4.26733 21.0248 3.97917 21.1261 3.7005 21.2655C3.42817 21.4048 3.20967 21.6043 3.045 21.864C2.88033 22.13 2.798 22.4403 2.798 22.795C2.798 23.1433 2.874 23.4473 3.026 23.707C3.18433 23.9666 3.39333 24.1661 3.653 24.3055C3.919 24.4448 4.19767 24.5461 4.489 24.6095C4.78667 24.6728 5.10017 24.7045 5.4295 24.7045ZM2 31.9178L2 27.8708L8.3745 27.8708C8.38083 27.8708 8.42833 27.8613 8.517 27.8423C8.60567 27.8233 8.6975 27.8012 8.7925 27.7758C8.8875 27.7568 8.94133 27.7473 8.954 27.7473L8.954 29.1913L2.9405 29.1913L2.9405 31.9178L2 31.9178ZM2 37.7477L2 33.7007L8.3745 33.7007C8.38083 33.7007 8.42833 33.6912 8.517 33.6722C8.60567 33.6532 8.6975 33.6311 8.7925 33.6057C8.8875 33.5867 8.94133 33.5772 8.954 33.5772L8.954 35.0212L2.9405 35.0212L2.9405 37.7477L2 37.7477Z"
		/>
	</svg>
)

const DownChevron = (props) => (
	<svg
		{...props}
		width="1em"
		height="1em"
		viewBox="0 0 10 4"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1 1L5 3.34375L9 1"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export {
	LogoSVG,
	InfoIcon,
	CircledProfileIcon,
	CircledInfoIcon,
	TimerFieldIcon,
	TextFieldIcon,
	SwitchIcon,
	ScrollArrow,
	DownChevron,
}
